export default "__VITE_ASSET__BYZX42Ke__"